'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = CarInfoPanel;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _basketHelpers = require('helpers/basketHelpers');

var _defaultClasses = require('../../../../../constants/defaultClasses');

var _dateTimeHelper = require('helpers/dateTimeHelper');

var _dateTimeHelper2 = _interopRequireDefault(_dateTimeHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _renderData = function _renderData(components, data, segment, type) {
  return _react2.default.createElement(
    'table',
    null,
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'span',
            { style: (0, _extends3.default)({}, (0, _defaultClasses.containerClass)(components.PickupTitleLabel)) },
            type
          )
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'span',
            { style: (0, _extends3.default)({}, (0, _defaultClasses.containerClass)(components.PickupValueLabel)) },
            data.address
          )
        )
      ),
      airportCode && _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'span',
            { style: (0, _extends3.default)({}, (0, _defaultClasses.containerClass)(components.PickupValueLabel)) },
            data.name + ' (' + data.airportCode + ')'
          )
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'span',
            { style: (0, _extends3.default)({}, (0, _defaultClasses.containerClass)(components.PickupValueLabel)) },
            data.city + ' ' + data.country
          )
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'span',
            { style: (0, _extends3.default)({}, (0, _defaultClasses.containerClass)(components.PickupValueLabel)) },
            segment
          )
        )
      )
    )
  );
};

function CarInfoPanel(props) {
  var option = props.option,
      components = props.components;


  return _react2.default.createElement(
    'table',
    { style: _defaultClasses.mainTableClass, 'data-component': 'CarHeader' },
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        { style: (0, _extends3.default)({}, (0, _defaultClasses.containerClass)(components.CarContainer)) },
        _react2.default.createElement(
          'td',
          { style: (0, _extends3.default)({}, (0, _defaultClasses.containerClass)(components.CarContainer), { padding: '10px' }) },
          _react2.default.createElement(
            'table',
            null,
            _react2.default.createElement(
              'tbody',
              null,
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  { style: { textAlign: 'center' } },
                  _react2.default.createElement('img', { src: 'https://goprivate.wspan.com/Scripts/us/GNG/ImagesGNG/car.png', alt: 'logo', style: { width: '50px', height: '50px' } })
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'td',
          { style: (0, _extends3.default)({}, (0, _defaultClasses.containerClass)(components.CarContainer), { padding: '10px' }) },
          _renderData(components, option.pickUp, _dateTimeHelper2.default.getDate(option.segment.startDateTime), 'Pick Up')
        ),
        _react2.default.createElement(
          'td',
          { style: (0, _extends3.default)({}, (0, _defaultClasses.containerClass)(components.CarContainer), { padding: '10px' }) },
          _renderData(components, option.dropOff, _dateTimeHelper2.default.getDate(option.segment.endDateTime), 'Drop Off')
        )
      )
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Car/Email/Passive/CarInfoPanel.jsx
// module id = 1505
// module chunks = 0